import { cn } from "../../lib/utils";

const STYLES = {
  NEW: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30",
  EXACT_MATCH: "bg-sky-500/15 text-sky-400 border-sky-500/30",
  PROBABLE_MATCH: "bg-indigo-500/15 text-indigo-300 border-indigo-500/30",
  CONFLICT: "bg-firered/15 text-firered border-firered/30",
  DUPLICATE_IN_FILE: "bg-fireorange/15 text-fireorange border-fireorange/30",
  INVALID: "bg-white/10 text-white/50 border-white/20",
  WARNING: "bg-amber/15 text-amber border-amber/30",
};
const LABELS = {
  NEW: "New", EXACT_MATCH: "Exact Match", PROBABLE_MATCH: "Probable",
  CONFLICT: "Conflict", DUPLICATE_IN_FILE: "Duplicate", INVALID: "Invalid", WARNING: "Warning",
};

export function ImportBadge({ status, className }) {
  return (
    <span data-testid={`import-badge-${status}`}
      className={cn("inline-flex items-center rounded-full px-2.5 py-0.5 text-[11px] font-semibold border tracking-wide whitespace-nowrap",
        STYLES[status] || "bg-white/10 text-white/60 border-white/20", className)}>
      {LABELS[status] || status}
    </span>
  );
}
